document.addEventListener("DOMContentLoaded", function() {
    console.log("DOM loaded");
    
    if (jQuery('.swiper-digital-wrapper').length) {
        console.log("Swiper Home trovato");
        
        // Verifica se gli elementi per il progresso esistono
        const progressCircle = document.querySelector(".autoplay-progress svg");
        const progressContent = document.querySelector(".autoplay-progress span");
        
        // Inizializza lo Swiper
        const swiperHome = new Swiper(".swiper-digital-wrapper", {
            slidesPerView: 1,
            centeredSlides: true,
            effect: 'fade',
            loop: true,
            initialSlide: 0,
            pagination: {
                el: ".swiper-pagination",
                type: "fraction",
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            autoplay: {
                delay: 7000,
                disableOnInteraction: false
            },
            on: {
                autoplayTimeLeft(s, time, progress) {
                    if (progressCircle) {
                        progressCircle.style.setProperty("--progress", 1 - progress);
                    }
                    if (progressContent) {
                        progressContent.textContent = `${Math.ceil(time / 1000)}s`;
                    }
                }
            }
        });
        
        // Forza l'avvio dell'autoplay
        swiperHome.autoplay.start();
        
        // Debug per verificare lo stato dell'autoplay
        console.log("Autoplay running:", swiperHome.autoplay.running);
    }
});